'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const OfferLifestyleImage = require('../../modules/shared/views/offer/offer-lifestyle-image');
const MerchantLogoImage = require('../../modules/shared/views/merchants/merchant-logo-image');
const OfferExpiry = require('../../modules/shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../modules/shared/views/offer/offer-view-terms');
const OfferRedemptionCount = require('../../modules/shared/views/offer/offer-redemption-count');
const CouponButton = require('../../modules/coupons/views/coupon-button');

function CouponUber({ coupon, routes, lazy = false }) {
  const { offerMedia } = coupon;
  if (
    !offerMedia.length ||
    !offerMedia.find(
      ({ isMainImage, mediaType }) =>
        !isMainImage && mediaType === 'OfferLifestyleImage'
    )
  ) {
    return null;
  }

  const showMerchantLogo = !!coupon.merchant;

  const { isExclusive } = coupon;

  return h(`.uber-card`, [
    OfferLifestyleImage({
      className: 'uber-card-image',
      data: coupon.offerMedia,
      alt: coupon.offerTitle,
      size: ['w_728,h_257,c_fill'],
      lazyload: lazy,
    }),

    showMerchantLogo &&
      MerchantLogoImage({
        className: 'uber-card-logo',
        alt: `${coupon.merchantName} - ${coupon.offerCallout}`,
        data: coupon.merchant.merchantMedia,
        size: ['w_70'],
        lazyload: lazy,
      }),

    h(`.uber-card-content${showMerchantLogo ? '.merchant-logo' : ''}`, [
      h('.uber-card-content-header', [
        h(WithI18n, {}, i18n =>
          h(
            `.description.should-truncate${isExclusive ? '.icon-logo-g' : ''}`,
            [
              isExclusive && h('strong', i18n.t('js.modules.shared.Exclusive')),
              coupon.offerTitle,
            ]
          )
        ),
        h(CouponButton, {
          coupon,
          routes,
          className: 'uber-card-button',
        }),
      ]),
      h('.uber-card-content-footer', [
        h('', [
          OfferRedemptionCount({
            stats: coupon.offerStatistics,
          }),
          OfferExpiry({
            className: 'uber-card-dealdata',
            expires: coupon.expiryDateTime,
          }),
        ]),
        OfferViewTerms({
          routes,
          offerId: coupon.offerId,
          className: 'uber-card-terms',
        }),
      ]),
    ]),
  ]);
}

module.exports = CouponUber;
